import React, {useMemo, useState} from 'react';
import { Inbox } from 'lucide-react';
import { PageHeading, Empty } from '../components/Common';
import { SearchField } from '../components/SearchField';
import { TicketTable } from '../components/tickets/TicketTable';
import { demoTickets } from '../lib/demo';
import { GoogleSignInButton } from '../auth/AuthControls';

export default function PublicTickets() {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => demoTickets.filter(ticket => `${ticket.title} ${ticket.number} ${ticket.message}`.toLowerCase().includes(query.toLowerCase())), [query]);
  return <div className="page-enter" data-testid="public-demo-tickets">
    <PageHeading eyebrow="EVERY CONVERSATION, ACCOUNTED FOR." title="Ticket log" subtitle="3 sample conversations · Public demo" action={<GoogleSignInButton testId="demo-tickets-sign-in"/>}/>
    <div className="ticket-tools"><SearchField prefix="tickets-search" label="Search sample tickets" value={query} onChange={setQuery} placeholder="Search sample conversations…"/></div>
    {filtered.length ? <TicketTable tickets={filtered} total={demoTickets.length} onDelete={() => undefined} readOnly/> : <Empty icon={Inbox} title="No sample conversations match" text="Try another search."/>}
  </div>;
}